export default __webpack_public_path__ + "static/media/13-2.38956f75.mp3";